import React from 'react';
import './index.css';

import logoDNI from 'assets/images/logo-cuentadni.png';
import mobile from 'assets/images/mobile-dni.png';
import btnGooglePlay from 'assets/images/btn-googleplay.png';
import btnAppStore from 'assets/images/btn-appstore.png';
import icodescarga from 'assets/images/ico-descarga.png';
import qrcode from 'assets/images/qr-code.jpg';

function Article({ variant }) {

  return (
    <div className='columns'>
      <div className='col'>
        <img src={logoDNI} alt="Cuenta DNI" className='logo-dni' />
        <div className="intro">
          { (variant === 'mayores' || variant === 'emprendedora') && (
            <>
              <p className='strong'>Cuenta DNI es la billetera digital del Banco Provincia, simple y segura, que nos incluye financieramente a todas y todos.</p>
              <p className='strong'>Es una solución digital de inclusión financiera SIN costos. Tanto la aplicación como la caja de ahorros no tienen costo de mantenimiento para todos los casos.</p>
            </>
          )}
          { variant === 'adolescentes' && (
            <>
              <p>Cuenta DNI es una billetera digital para celulares. Para obtenerla, sólo tenés que descargar la app en tu celular sin necesidad de autorización de representantes legales o mayores.</p>
              <h5>Al activar la billetera digital, accedés a una caja de ahorros gratuita a tu nombre y a una tarjeta de débito, sin costos asociados.</h5>
              <p>Si ya sos cliente de Banco Provincia, Cuenta DNI va a vincularse directamente con tu caja de ahorro.</p>
            </>
          )}
        </div>
        <div className="descargar">
          <div>
            <img src={icodescarga} alt="Icono de descarga" className='ico' />
            <p>¡Escaneá el código para descargar la app!</p>
          </div>
          <div>
            <img src={qrcode} alt="Código QR" className='qr' />
          </div>
        </div>
      </div>
      <div className='col'>
        <h4>¿Qué podemos hacer con una billetera virtual?</h4>
        <ul className='icons-list cuentadni'>
          <li className='enviar'>
            <i></i>
            <span>Enviar y recibir dinero en el momento! Desde una cuenta bancaria o desde otra billetera virtual. Solo necesitás el número de DNI, CBU/Alias.</span>
          </li>
          <li className='facturas'>
            <i></i>
            <span>Abonar facturas de servicios.<br />Agregá tus impuestos a la agenda y pagalos, estés donde estés.</span>
          </li>
          <li className='compras'>
            <i></i>
            <span>Pagar tus compras sin manipular dinero mostrando el código QR o con Clave DNI. Olvidate de la billetera!</span>
          </li>
          <li className='recarga'>
            <i></i>
            <span>Recargá tarjetas de transporte en cualquier momento y lugar.</span>
          </li>
          { variant === 'adolescentes' && (
            <>
              <li className='celular'>
                <i></i>
                <span>Recargar tu celular cada vez que lo necesites para mantenerte conectado.</span>
              </li>
              <li className='retirar'>
                <i></i>
                <span>Retirar efectivo sin llevar la tarjeta de débito. Generá una orden de extracción y listo!</span>
              </li>
            </>
          )}
        </ul>
      </div>
      <div className='col mobile'>
        <img src={mobile} alt="Descargá la aplicación" className='mockup' />
        <h5>Descargá la aplicación</h5>
        <div className='buttons'>
          <a href="https://play.google.com/store/apps/details?id=ar.com.bancoprovincia.CuentaDNI" target='_blank' rel='noreferrer'>
            <img src={btnGooglePlay} alt='Descarga nuestra aplicación en Android' />
          </a>
          <a href="https://www.bancoprovincia.com.ar/CDN/Get/AppStore" target='_blank' rel='noreferrer'>
            <img src={btnAppStore} alt='Descarga nuestra aplicación en iOS' />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Article;
